//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"LineardimBaseCornerRadius",0,"Expression",0],[0,"MaterialName",1,0],[0,"MetallicBase",1,0]],[[["filename"],"SetBaseColorTexture",{},1,0],[[],"GetBaseColorTexture",{R_:{filename:''}},0,0],[["blendToggle"],"SetBaseColorBlend",{},1,0],[[],"GetBaseColorBlend",{R_:{blendToggle:''}},0,0],[["nRGBColorPickerColor"],"GetBaseColor",{R_:{rGBColorPickerColor:""}},0,0],[["rGBColorPickerColor"],"SetBaseColor",{},1,0],[["filename"],"SetBaseMicroSurfaceShadowTexture",{},1,0],[[],"GetBaseMicroSurfaceShadowTexture",{R_:{filename:''}},0,0],[["filename"],"SetBaseGeometryCutoutTexture",{},1,0],[[],"GetBaseGeometryCutoutTexture",{R_:{filename:''}},0,0]],[]];
SPLM.Display.VisualMaterialEditorBaseBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.VisualMaterialEditorBaseBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.VisualMaterialEditorBaseBuilder.MetallicBaseType = Object.freeze({
    "NonMetallic" : "NonMetallic", "Metallic" : "Metallic"});

export default SPLM;